module.exports = __webpack_public_path__ + "static/media/em-53.2e8a83c8.png";